function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoNFT = require('../../../lib/saito/ui/saito-nft/saito-nft');
var _require = require('./summary-media'),
  DREAMSCAPE_PLACEHOLDER = _require.DREAMSCAPE_PLACEHOLDER,
  _ensureListingTransaction = _require.ensureListingTransaction,
  enrichSummaryMedia = _require.enrichSummaryMedia;
var _require2 = require('./categories'),
  STORE_CATEGORIES = _require2.STORE_CATEGORIES;
var SUMMARY_STATUS_ACTIVE = 1;
var SUMMARY_STATUS_INACTIVE = 0;
var Summary = /*#__PURE__*/function () {
  function Summary(app, mod) {
    var _data$id, _data$image, _data$price, _ref, _data$quantity_availa, _data$quantity_total, _data$status, _data$quantity_sold, _data$approved;
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Summary);
    this.app = app;
    this.mod = mod;
    this.id = (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : 0;
    this.nft_id = data.nft_id || '';
    this.seller = data.seller || '';
    this.category = data.category || STORE_CATEGORIES.OTHER;
    this.title = data.title || '';
    this.description = data.description || '';
    this.image = (_data$image = data.image) !== null && _data$image !== void 0 ? _data$image : null;
    this.price = (_data$price = data.price) !== null && _data$price !== void 0 ? _data$price : 0;
    this.web3_ticker = String(data.web3_ticker || '').trim().toUpperCase();
    this.web3_amount = String(data.web3_amount || '').trim();
    this.quantity_available = (_ref = (_data$quantity_availa = data.quantity_available) !== null && _data$quantity_availa !== void 0 ? _data$quantity_availa : data.quantity) !== null && _ref !== void 0 ? _ref : 0;
    this.quantity_total = (_data$quantity_total = data.quantity_total) !== null && _data$quantity_total !== void 0 ? _data$quantity_total : Number(this.quantity_available);
    this.status = (_data$status = data.status) !== null && _data$status !== void 0 ? _data$status : SUMMARY_STATUS_ACTIVE;
    this.created_at = Number(data.created_at || 0);
    this.updated_at = data.updated_at || 0;
    this.subtitle = data.subtitle || '';
    this.badge = data.badge;
    this.nft = data.nft || null;
    this.listing_signature = data.listing_signature || '';
    this.listing_tx = data.listing_tx || null;
    this._image_source = data._image_source || null;
    this._media_enriched = data._media_enriched || false;
    this.note = data.note || '';
    this.buyer = data.buyer || '';
    this.seller_note = data.seller_note || '';
    this.quantity_sold = Number((_data$quantity_sold = data.quantity_sold) !== null && _data$quantity_sold !== void 0 ? _data$quantity_sold : 0) || 0;
    this.sold_at = Number(data.sold_at || 0) || 0;
    this.approved = Number((_data$approved = data.approved) !== null && _data$approved !== void 0 ? _data$approved : 0);
    if (!Number.isFinite(this.approved)) {
      this.approved = 0;
    }
    this.risk = data.risk === 'Low' || data.risk === 'Medium' || data.risk === 'High' || data.risk === 'Dangerous' ? data.risk : '';
  }
  return _createClass(Summary, [{
    key: "returnPlaceholderImage",
    value: function returnPlaceholderImage() {
      var _this$nft, _this$nft2, _this$nft3;
      var type = (typeof ((_this$nft = this.nft) === null || _this$nft === void 0 ? void 0 : _this$nft.returnType) === 'function' ? this.nft.returnType() : '') || ((_this$nft2 = this.nft) === null || _this$nft2 === void 0 ? void 0 : _this$nft2.nft_type) || '';
      if (type === 'saito-app' || (_this$nft3 = this.nft) !== null && _this$nft3 !== void 0 && _this$nft3.saito) {
        return '/saito/img/application.png';
      }
      return DREAMSCAPE_PLACEHOLDER;
    }
  }, {
    key: "isImageLoading",
    value: function isImageLoading() {
      return this.returnMediaDisplay().loading;
    }
  }, {
    key: "hasLoadedImage",
    value: function hasLoadedImage() {
      return !!this.image;
    }
  }, {
    key: "returnMediaDisplay",
    value: function returnMediaDisplay() {
      var _this$nft4;
      if ((_this$nft4 = this.nft) !== null && _this$nft4 !== void 0 && _this$nft4.returnMediaDisplay) {
        var display = this.nft.returnMediaDisplay();
        if (!display.loading || !this._media_enriched) {
          return display;
        }
      }
      if (this.image) {
        return {
          backgroundImage: this.image,
          innerHtml: '',
          loading: false,
          failed: false
        };
      }
      if (this._media_enriched) {
        return {
          backgroundImage: this.returnPlaceholderImage(),
          innerHtml: '',
          loading: false,
          failed: false
        };
      }
      return {
        backgroundImage: '',
        innerHtml: '',
        loading: true,
        failed: false
      };
    }
  }, {
    key: "returnImage",
    value: function returnImage() {
      var _this$nft5, _this$nft5$returnImag;
      if (this.image) {
        return this.image;
      }
      var nft_image = ((_this$nft5 = this.nft) === null || _this$nft5 === void 0 || (_this$nft5$returnImag = _this$nft5.returnImage) === null || _this$nft5$returnImag === void 0 ? void 0 : _this$nft5$returnImag.call(_this$nft5)) || '';
      if (nft_image) {
        return nft_image;
      }
      return this.returnPlaceholderImage();
    }
  }, {
    key: "returnCacheImageUrl",
    value: function returnCacheImageUrl() {
      var _this$nft_id, _this$mod, _this$mod$returnSlug;
      var nft_id = String((_this$nft_id = this.nft_id) !== null && _this$nft_id !== void 0 ? _this$nft_id : '');
      if (!nft_id) {
        return '';
      }
      var slug = ((_this$mod = this.mod) === null || _this$mod === void 0 || (_this$mod$returnSlug = _this$mod.returnSlug) === null || _this$mod$returnSlug === void 0 ? void 0 : _this$mod$returnSlug.call(_this$mod)) || 'store';
      return "/".concat(encodeURI(slug), "/cache/").concat(encodeURIComponent(nft_id), ".img");
    }
  }, {
    key: "returnTitle",
    value: function returnTitle() {
      var _this$nft6;
      this.hydrateFromListingTransaction();
      var title = String(this.title || ((_this$nft6 = this.nft) === null || _this$nft6 === void 0 ? void 0 : _this$nft6.title) || '').trim();
      return title || 'Untitled Item';
    }
  }, {
    key: "returnDescription",
    value: function returnDescription() {
      var _ref2, _this$description, _this$nft7;
      this.hydrateFromListingTransaction();
      return (_ref2 = (_this$description = this.description) !== null && _this$description !== void 0 ? _this$description : (_this$nft7 = this.nft) === null || _this$nft7 === void 0 ? void 0 : _this$nft7.description) !== null && _ref2 !== void 0 ? _ref2 : '';
    }
  }, {
    key: "returnSeller",
    value: function returnSeller() {
      this.hydrateFromListingTransaction();
      return String(this.seller || '').trim();
    }
  }, {
    key: "returnQuantity",
    value: function returnQuantity() {
      var _this$quantity_availa;
      return Number((_this$quantity_availa = this.quantity_available) !== null && _this$quantity_availa !== void 0 ? _this$quantity_availa : 0) || 0;
    }
  }, {
    key: "returnPrice",
    value: function returnPrice() {
      this.hydrateFromListingTransaction();
      var ticker = String(this.web3_ticker || '').trim().toUpperCase();
      var amount = String(this.web3_amount || '').trim();
      if (ticker && ticker !== 'SAITO' && amount) {
        return "".concat(amount, " ").concat(ticker);
      }
      try {
        var _this$price, _this$app;
        var nolan = BigInt((_this$price = this.price) !== null && _this$price !== void 0 ? _this$price : 0);
        if (nolan > 0n && (_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.wallet) !== null && _this$app !== void 0 && _this$app.convertNolanToSaito) {
          return "".concat(this.app.wallet.convertNolanToSaito(nolan), " SAITO");
        }
        if (nolan > 0n) {
          return String(nolan);
        }
      } catch (err) {
        // Non-integral / unexpected price values should not blank the card.
      }
      var raw = this.price;
      if (raw != null && raw !== '' && Number(raw) !== 0) {
        return String(raw);
      }
      return '';
    }

    /**
     * Pull display fields from an already-attached listing tx when Summary
     * surface fields are empty (same source listing detail uses after open).
     */
  }, {
    key: "hydrateFromListingTransaction",
    value: function hydrateFromListingTransaction() {
      if (!this.listing_tx) {
        return this;
      }
      var hasTitle = !!String(this.title || '').trim();
      var hasSeller = !!String(this.seller || '').trim();
      var hasPrice = Number(this.price) > 0;
      if (hasTitle && hasSeller && hasPrice && this.nft) {
        return this;
      }
      var _require3 = require('./summary-media'),
        applyListingTransaction = _require3.applyListingTransaction;
      applyListingTransaction(this, this.listing_tx);
      return this;
    }
  }, {
    key: "isActive",
    value: function isActive() {
      var _this$quantity_availa2;
      return Number((_this$quantity_availa2 = this.quantity_available) !== null && _this$quantity_availa2 !== void 0 ? _this$quantity_availa2 : 0) > 0;
    }
  }, {
    key: "attachNFT",
    value: function attachNFT(nft) {
      if (!nft) {
        return this;
      }
      this.nft = nft;
      if (!this.image) {
        var _nft$returnImage;
        var image = ((_nft$returnImage = nft.returnImage) === null || _nft$returnImage === void 0 ? void 0 : _nft$returnImage.call(nft)) || '';
        if (image) {
          this.image = image;
        }
      }
      return this;
    }
  }, {
    key: "ensureListingTransaction",
    value: function ensureListingTransaction() {
      var onComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var done = function done(summary) {
        if (onComplete) {
          onComplete(summary);
        }
        return summary;
      };
      return _ensureListingTransaction(this).then(done);
    }
  }, {
    key: "enrichMedia",
    value: function enrichMedia() {
      var onComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var done = function done(summary) {
        if (onComplete) {
          onComplete(summary);
        }
        return summary;
      };
      return enrichSummaryMedia(this).then(done);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        nft_id: this.nft_id,
        seller: this.seller,
        category: this.category || STORE_CATEGORIES.OTHER,
        title: this.title,
        description: this.description,
        listing_signature: this.listing_signature || '',
        price: this.price,
        web3_ticker: this.web3_ticker || '',
        web3_amount: this.web3_amount || '',
        quantity_total: this.quantity_total,
        quantity_available: this.quantity_available,
        status: this.status,
        created_at: this.created_at,
        updated_at: this.updated_at,
        subtitle: this.subtitle,
        badge: this.badge,
        note: this.note || '',
        buyer: this.buyer || '',
        quantity_sold: this.quantity_sold || 0,
        sold_at: this.sold_at || 0,
        approved: Number.isFinite(this.approved) ? this.approved : 0,
        risk: this.risk || ''
      };
    }
  }]);
}();
module.exports = Summary;
module.exports.SUMMARY_STATUS_ACTIVE = SUMMARY_STATUS_ACTIVE;
module.exports.SUMMARY_STATUS_INACTIVE = SUMMARY_STATUS_INACTIVE;
module.exports.DREAMSCAPE_PLACEHOLDER = DREAMSCAPE_PLACEHOLDER;